export function enumKeys<O extends object, K extends keyof O = keyof O>(obj: O): K[] {
  return Object.keys(obj).filter((k) => Number.isNaN(+k)) as K[];
}

async function copyToClipboardFallback(text: string) {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.style.position = 'fixed';
  textarea.style.opacity = '0';
  document.body.appendChild(textarea);
  textarea.select();

  try {
    // TODO: use clipboard API
    document.execCommand('copy');
  } catch (err) {
    console.error('Failed to copy text', err);
  }
  document.body.removeChild(textarea);
}

export async function copyToClipboard(text: string) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    try {
      await navigator.clipboard.writeText(text);
    } catch (err) {
      await copyToClipboardFallback(text);
    }
  } else {
    await copyToClipboardFallback(text);
  }
}
